$( document ).ready(function() {
  // MARQUEE
  Marquee3k.init({
    selector: 'marquee3k'
  });

  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
    	$("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  };

  // HANDLE VIDEO PLAY/PAUSE
  const videoToggleButtons = document.querySelectorAll(".toggleButton");
  for (let i = 0; i < videoToggleButtons.length; i++) {
    const video = videoToggleButtons[i].nextElementSibling;
    const toggleButton = videoToggleButtons[i];
    function togglePlay() {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    }
    function updateToggleButton() {
      toggleButton.classList.toggle('play', video.paused || video.ended);
    }
    toggleButton.addEventListener("click", togglePlay);
    video.addEventListener("click", togglePlay);
    video.addEventListener("play", updateToggleButton);
    video.addEventListener("pause", updateToggleButton);
  }

  // HOME SWIPER
  var homeSwiper = new Swiper('.home-intro', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' + '<span class="' + totalClass + '"></span>';
      },
    },
  });

  // SLIDER-ITEMS-SECTION SWIPER
  var sectionSwiper = new Swiper('.slider-items-swipper', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 2,
    spaceBetween: 5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },

    }
  });

  // SHOPIFY MONEY FORMAT HANDLER
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  // FOOTER HEIGHT
  function updateFooterHeight() {
    var footerHeight = $('footer').outerHeight();
    document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
  }
  updateFooterHeight();
  $(window).resize(function() {
    updateFooterHeight();
  });

  // HEADER MOBILE MENU
  var menuOpen = document.querySelector('#open-mobile-nav');
  var menuClose = document.querySelector('#close-mobile-nav');
  var menu = document.querySelector('#mobile-nav-dialog');
  menuOpen.addEventListener('click', function() {
    menu.showModal();
  });
  menuClose.addEventListener('click', function() {
    menu.close();
  });

  // HEIGHT VIEWPORT
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  $( window ).on( "resize", function() {
    // HEIGHT VIEWPORT
    const windowHeight = document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  });

  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);

  // ADD TARGET TO TAG
  const isExternalURL = (url) => new URL(url).origin !== location.origin;
  var aTags = document.querySelectorAll('a');
  for (var i = 0; i < aTags.length; i++) {
    if (isExternalURL(aTags[i].href)) {
      aTags[i].target = '_blank';
      aTags[i].rel = 'noopener noreferrer';
    }
  }

  const videos = document.querySelectorAll('.cover-video');
  videos.forEach(video => {
    const mobilePoster = video.dataset.mobilePoster;
    
    if (mobilePoster) {
      const mediaQuery = window.matchMedia('(max-width: 1239px)');
      
      function handleMediaChange(e) {
        video.poster = e.matches ? mobilePoster : video.dataset.defaultPoster;
      }
      
      video.dataset.defaultPoster = video.poster;
      mediaQuery.addListener(handleMediaChange);
      handleMediaChange(mediaQuery);
    }
  });
});